<template>
  <div>
    <v-container>
      <date-filter
        v-model="selectedDate"
        @changeDate="handleFilterDate"
        :defaultFilter="'last_7_days'"
      />

      <v-layout wrap justify-between align-center class="pt-4 v-sheet theme--light">
        <v-flex xs6>
          <v-flex class="form-control with-icon icon-end">
            <input
              placeholder="Search"
              type="text"
              v-model="searchKeyword"
              @keydown.enter="handleSearchKeyword"
              @blur="handleSearchKeyword"
            />
            <span class="icon" @click="handleSearchKeyword" style="cursor: pointer">
              <v-icon>search</v-icon>
            </span>
          </v-flex>
        </v-flex>
        <v-flex xs6 text-xs-right>
          <v-btn dark outline color="primary" @click="showDialogSop = true">
            {{ $t('add') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <CardSop
        v-for="(item, index) in listing"
        :key="index"
        :item="item"
        @changeActive="handleChangeActive"
        @editSop="handleEditSop"
        @duplicateSop="handleDuplicateSop"
        @deleteSop="onDeleteSop"
      ></CardSop>

      <template v-if="isLoaded && listing.length === 0">
        <v-flex pa-3> no result </v-flex>
      </template>

      <v-flex mt-2 v-else>
        <v-pagination
          v-model="pageNumber"
          :length="pageCount"
          @input="handleOnClickPagination"
        ></v-pagination>
      </v-flex>
    </v-container>

    <v-dialog v-model="showDialogSop" persistant width="850px">
      <template v-if="showDialogSop">
        <DialogSop @close="handleOnCloseDialog" :itemEdit="itemToEdit"></DialogSop>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import DialogSop from './DialogSop.vue'
import CardSop from './CardSop.vue'
import hopinnHrApi from '@/api/hopinn-hr'

export default {
  components: {
    DateFilter,
    DialogSop,
    CardSop
  },
  data() {
    return {
      searchKeyword: null,
      showDialogSop: false,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      listing: [],
      total: 0,
      pageNumber: 1,
      size: 10,
      isLoaded: false,
      itemToEdit: null
    }
  },
  computed: {
    pageCount: function () {
      const total = this.total
      const size = this.size
      const result = Math.ceil(total / size)
      return result === 0 ? 1 : result
    }
  },
  async mounted() {
    await this.handleFetchSopListing()
    await this.$store.dispatch('loadSetting')
    await this.$store.dispatch('loadCategory')
    await this.$store.dispatch('loadProducts')
  },
  methods: {
    handleEditSop(item) {
      this.itemToEdit = item
      this.showDialogSop = true
    },
    async handleChangeActive(item) {
      const vm = this

      try {
        vm.$store.dispatch('loading')
        const updateResponse = await hopinnHrApi.updateSop({
          data: {
            id: item.id,
            pageid: item.pageid,
            name: item.name,
            active: !item.active
          }
        })
        vm.$store.dispatch('loading')
        if (updateResponse.data.responsecode === 200) {
          vm.handleFetchSopListing()
        }
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    },
    async handleDuplicateSop(item) {
      const vm = this
      try {
        vm.$store.dispatch('loading')

        const duplicateResponse = await hopinnHrApi.postCreateSop({
          data: {
            pageid: item.pageid,
            name: `${item.name} - copy`,
            day_length: item.day_length,
            division: item.division,
            department: item.department,
            a_val: item.a_val,
            affiliation: item.affiliation,
            active: false
          }
        })
        vm.$store.dispatch('loading')
        if (duplicateResponse.data.responsecode === 200) {
          vm.handleResetFilter()
          vm.handleFetchSopListing()
        }
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    },
    onDeleteSop(id) {
      this.$swal
        .fire({
          icon: 'error',
          text: 'คุณต้องการลบใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        })
        .then((result) => {
          if (result.value) {
            this.handleDeleteSop(id)
          }
        })
    },
    async handleDeleteSop(id) {
      const vm = this
      try {
        vm.$store.dispatch('loading')

        const deleteSopResponse = await hopinnHrApi.deleteSop({
          data: {
            id
          }
        })
        vm.$store.dispatch('loading')
        if (deleteSopResponse.data.responsecode === 200) {
          vm.handleFetchSopListing()
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    handleResetFilter() {
      this.searchKeyword = null
      this.listing = []
      this.pageNumber = 1
    },
    handleSearchKeyword() {
      this.handleFetchSopListing()
    },
    handleOnCloseDialog(message) {
      if (message === 'refetchSop') {
        this.handleResetFilter()
        this.handleFetchSopListing()
      }
      this.itemToEdit = null
      this.showDialogSop = false
    },
    handleFilterDate() {
      this.handleFetchSopListing()
    },
    async handleFetchSopListing() {
      const vm = this
      vm.isLoaded = true
      vm.$store.dispatch('loading')
      try {
        const limit = vm.size
        const offset = vm.size * vm.pageNumber - vm.size
        const datefrom = vm.selectedDate.start
        const dateto = vm.selectedDate.end
        const name = vm.searchKeyword !== '' ? vm.searchKeyword : null
        const sopListingResponse = await hopinnHrApi.getSopListing({
          config: {
            params: {
              limit,
              offset,
              datefrom,
              dateto,
              name
            }
          }
        })
        if (sopListingResponse.data.data) {
          vm.listing = sopListingResponse.data.data
          if (sopListingResponse.data.data.length > 0)
            vm.total = sopListingResponse.data.data[0].total
        }
        vm.$store.dispatch('loading')
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    },
    handleOnClickPagination() {
      this.handleFetchSopListing()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/HopinnHr/SopManagement.vue